<template>
    <div class="ly-loginback sk-loginback">
        <div class="ly-login sk-login">
            <input type="text" v-model="userName" ref="code" @keypress="codeKeyHandler" placeholder="请输入用户名" />
            <input type="password" v-model="passWord" ref="pwd" @keypress="pwdKeyHandler" placeholder="请输入用密码" />
            <el-checkbox v-model="remember" class="rememberName">记住用户名</el-checkbox>

            <el-button type="primary" class="login-button" @click="login">登录</el-button>
        </div>
    </div>
</template>
<script>
import auth from "../scripts/auth";

export default {
    data() {
        return {
            userName: "",
            passWord: "",
            langName: "",
            userKey: "__AJS_Report_Login_UserName",
            remember: false,
        };
    },
    name: "login",
    components: {},
    created() {
        let name = localStorage.getItem(this.userKey);
        if (name) {
            this.userName = name;
        }
        // let lang = this.$langList.filter((item) => item.value === this.$lang.langCode)[0];
        // this.langName = lang.text;
        // document.title = this.$lang.pageTitle;
    },
    mounted() {},
    methods: {
        changeLanguage(item) {
            this.langName = item.text;
            this.$lang.changeLang(item.value);
            document.title = this.$lang.pageTitle;
        },
        codeKeyHandler(e) {
            if (e.keyCode === 13) {
                this.$refs.pwd.focus();
            }
        },
        pwdKeyHandler(e) {
            if (e.keyCode === 13) {
                this.login();
            }
        },
        login() {
            this.$ajax
                .post("/account/login", {
                    UserCode: this.userName,
                    Password: this.passWord,
                })
                .then((res) => {
                    auth.saveToken(res.Data, 10000);
                    this.loginSuccess();
                });
        },
        loginCallback(result) {
            if (result && result.Success) {
                auth.saveToken(result.Data, 10000);
                this.loginSuccess();
            }
        },
        loginSuccess() {
            if (this.remember) {
                localStorage.setItem(this.userKey, this.userName);
            }
            this.$router.push({ path: "/" });
        },
    },
};
</script>

<style scoped>
.center {
    text-align: center;
}

.ly-loginback {
    width: 100%;
    height: 100%;
    background: url(../styles/imgs/login-bg.jpg);
}

.sk-loginback {
    background-color: #2d3a4b;
}

.ly-login {
    width: 557px;
    height: 664px;
    position: absolute;
    top: 200px;
    left: 100px;
    overflow: hidden;
    background: url(../styles/imgs/login-bg-form.png);
}

.ly-login .ly-line {
    width: 100%;
    height: 50px;
    line-height: 50px;
    padding: 10px 0px;
    display: inline-block;
    position: relative;
}

.sk-title {
    font-family: 微软雅黑;
    color: #007aff;
    font-size: 24px;
    font-weight: bolder;
}

.icon {
    position: absolute;
    top: 15px;
    left: 10px;
    height: 40px;
    line-height: 40px;
}
.login-button {
    position: absolute;
    top: 480px;
    left: 130px;
    width: 320px;
    height: 60px;
    border-radius: 30px;
    background-color: #4f93fe;
    color: #fff;
    font-size: 20px;
}

span.text {
    padding: 0 10px;
}

input[type="text"],
input[type="password"] {
    height: 32px;
    line-height: 32px;
    -webkit-appearance: none;
    background-color: transparent !important;
    background-image: none;
    border-radius: 4px;
    border: none;
    box-sizing: border-box;
    color: #a9a9a9;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 300px;
}

input[type="text"].prefix,
input[type="password"].prefix {
    padding-left: 32px;
}

input[type="text"] {
    left: 150px;
    top: 250px;
    position: absolute;
}
input[type="password"] {
    left: 150px;
    top: 350px;
    position: absolute;
}

.rememberName {
    position: absolute;
    top: 430px;
    left: 110px;
}
</style>
